import { Shark } from "shark-mvc";

import templateContent from "./main-nav.html";
import { refuelEditView } from "../../_shark_jaws/views/refuelEditView";
import { loginView } from "../../_shark_jaws/views/loginView";
import { homeView } from "../../_shark_jaws/views/homeView";
import { vehiclePickUpView } from "../../_shark_jaws/views/vehiclePickUpView";
import { vehicleReturnView } from "../../_shark_jaws/views/vehicleReturnView";
import { verifyVehicleView } from "../../_shark_jaws/views/verifyVehicleView";

var mainNavComponent = Shark.createJaw("mainNavComponent");
mainNavComponent.templateContent = templateContent;

mainNavComponent.addMethod("beforeRender", function () {
	const activePageId = Shark.activePage.id;
	const activePage = this.get("activePage");

	//Dave.ToDo: mettere un controllo se esiste la proprietà
	for (let curr in activePage) {
		activePage[curr] = activePageId === curr;
	}

	activePage[activePageId] = true;

	this.set({
		activePage
	});
});

mainNavComponent.addMethod("init", function () {
	this.set({
		activePage: {}
	})
});

mainNavComponent.addMethod("navHomeBtn_clickHandler", function (event) {
	event.preventDefault();
	Shark.openPage(homeView);
});

mainNavComponent.addMethod("navLogoutBtn_clickHandler", function (event) {
	event.preventDefault();
	localStorage.removeItem("lastAccessToken");
	Shark.openPage(loginView);
});

mainNavComponent.addMethod("navNewRefuelBtn_clickHandler", function (event) {
	event.preventDefault();
	Shark.openPage(refuelEditView);
});

mainNavComponent.addMethod("navVehiclePickUpBtn_clickHandler", function (event) {
	event.preventDefault();
	Shark.openPage(vehiclePickUpView);
});

mainNavComponent.addMethod("navVehicleReturnBtn_clickHandler", function (event) {
	event.preventDefault();
	Shark.openPage(vehicleReturnView);
});

mainNavComponent.addMethod("navVerifyVehicleBtn_clickHandler", function (event) {
	event.preventDefault();
	Shark.openPage(verifyVehicleView);
});

Shark.registerComponent(mainNavComponent);

export { mainNavComponent };
